import React, { useMemo } from 'react';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import creatSagaMiddleware from 'redux-saga';
// import { createMuiTheme } from '@material-ui/core/styles';

import rootReducer from './reducers';
import rootSaga from './sagas';
import './App.css';
import { getCookie } from './utils';
import { setSessionId } from './actions/auth';
import { setUser } from './actions/user';
import { selectPod, setAffilateData } from './actions/pods';
import { setPayment } from './actions/payment';
import { selectOrder, setPendingOrders, setAllLiveOrders } from './actions/orders';
import { setLoadAmount } from './actions/wallet';
import Container from './Container';
import SentryErrorBoundary from './components/sentry/sentry';
import { FirebaseContext, firebase } from './context/firebase';
import { AFFILIATE_ACTIVE, AFFILIATE_DATA } from './constants';
import { setDeliveryAddress } from './actions/delivery';

const sagaMiddleware = creatSagaMiddleware();
const composeEnhancers =
	process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
		? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
		: compose;
export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(sagaMiddleware)));
sagaMiddleware.run(rootSaga);

const GlobalCss = withStyles({
	'@global': {
		'.MuiButton-root': {
			borderRadius: '5px',
		},
	},
})(() => null);

function App() {
	const { dispatch } = store;
	// const theme = createMuiTheme({
	// 	palette: {
	// 		primary: {
	// 			main: '#bedc13',
	// 		},
	// 	},
	// });

	useMemo(() => {
		let user = getCookie('user');
		if (user) {
			user = JSON.parse(user);
			dispatch(setUser(user));
		}

		const sessionId = getCookie('sessionId');
		if (sessionId) {
			dispatch(setSessionId(sessionId));
		}

		const selectedPod = getCookie('pod');
		if (selectedPod) {
			dispatch(selectPod(JSON.parse(selectedPod)));
		} 

		const payment = getCookie('payment');
		if (payment) {
			dispatch(setPayment(JSON.parse(payment)));
		}

		const selectedOrder = getCookie('selectedOrder');
		if (selectedOrder) {
			dispatch(selectOrder(JSON.parse(selectedOrder)));
		}

		const pendingOrders = getCookie('pendingOrders');
		if (pendingOrders) {
			dispatch(setPendingOrders(JSON.parse(pendingOrders)));
		}

		const liveOrders = getCookie('liveOrders');
		if (liveOrders) {
			dispatch(setAllLiveOrders(JSON.parse(liveOrders)));
		}

		const walletLoadAmt = getCookie('walletLoadAmt');
		if (walletLoadAmt) {
			dispatch(setLoadAmount(+walletLoadAmt));
		}

		const active = getCookie(AFFILIATE_ACTIVE);
		const afflData = getCookie(AFFILIATE_DATA);
		if (active) {
			dispatch(setAffilateData(active, afflData && JSON.parse(afflData)));
		}

		const address = getCookie('address');
		if (address) {
			dispatch(setDeliveryAddress(JSON.parse(address)));
		}
	}, [dispatch]);

	return (
		<SentryErrorBoundary>
			<Provider store={store}>
				<FirebaseContext.Provider value={firebase}>
					<GlobalCss />
					<Container />
				</FirebaseContext.Provider>
			</Provider>
		</SentryErrorBoundary>
	);
}

export default App;
